import { AiOutlineCheckCircle, AiOutlineCloseCircle } from "react-icons/ai";
import { FiDownload } from "react-icons/fi";


function ViewBrand({ viewBrand, closeViewBrand, downloadCertificate }) {

    const formatPersianDate = (value) => {
        if (value === undefined || value === null || value === "") return "—";
        const parsed = Number(value);
        if (!Number.isNaN(parsed) && parsed > 0) {
            return new Intl.DateTimeFormat("fa-IR", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
            }).format(new Date(parsed));
        }
        return String(value);
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
                <div className="p-10">
                    <div className="flex flex-row-reverse justify-between items-center mb-6">
                        <h3 className="text-xl font-bold text-gray-800">جزئیات برند</h3>
                        <button
                            onClick={closeViewBrand}
                            className="text-gray-400 hover:text-gray-600"
                        >
                            ✕
                        </button>
                    </div>
                    <div className="space-y-4">
                        <div className="flex flex-row-reverse items-center gap-2">
                            <span className="text-2xl font-bold">{viewBrand.name}</span>
                            <span>-</span>
                            {viewBrand.isActive ?
                                <span className="text-xs text-green-800 bg-green-100 border border-green-200 rounded px-4 py-1">فعال</span>
                                :
                                <span className="text-xs text-gray-700 bg-gray-100 border border-gray-200 rounded px-4 py-1">غیر فعال</span>
                            }
                        </div>
                        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                            <div className="bg-gray-50 border border-gray-200 rounded-xl p-4">
                                <p className="text-xs text-gray-500 text-right">زبان</p>
                                <p className="mt-1 text-gray-800 text-right">{viewBrand.language === "PERSIAN" ? "فارسی" : "English"}</p>
                            </div>
                            <div className="bg-gray-50 border border-gray-200 rounded-xl p-4">
                                <p className="text-xs text-gray-500 text-right"> دامنه </p>
                                <p className="mt-1 text-gray-800 font-bold text-right">{viewBrand.domain}</p>
                            </div>
                        </div>
                        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                            <div className="bg-gray-50 border border-gray-200 rounded-xl p-4">
                                <p className="text-xs text-gray-500 text-right">آخرین بروز رسانی</p>
                                <p className="mt-1 text-gray-800 font-bold text-right">{formatPersianDate(viewBrand.updatedTime)}</p>
                            </div>
                            <div className="bg-gray-50 border border-gray-200 rounded-xl p-4">
                                <p className="text-xs text-gray-500 text-right">تاریخ ایجاد</p>
                                <p className="mt-1 text-gray-800 text-right">{formatPersianDate(viewBrand.createdTime)}</p>
                            </div>
                        </div>
                        <div className="bg-gray-50 border border-gray-200 rounded-xl p-4">
                            <p className="text-xs text-gray-500 text-right">توضیحات</p>
                            <p className="mt-1 text-gray-800 whitespace-pre-wrap text-right">{viewBrand.description || "—"}</p>
                        </div>
                        <div className="flex flex-col items-end bg-gray-50 border border-gray-200 rounded-xl p-4">
                            <span className="text-xs text-gray-500 text-right">سطح دسترسی</span>
                            <div className="flex items-center gap-2 ">
                                <span className="text-xs">دسترسی برند خود</span>
                                {viewBrand.accessOwnBrand ? (
                                    <AiOutlineCheckCircle className="text-green-600 text-lg" />
                                ) : (
                                    <AiOutlineCloseCircle className="text-red-600 text-lg" />
                                )}
                            </div>
                            <div className="flex items-center gap-2 ">
                                <span className="text-xs">دسترسی برند دیگر</span>
                                {viewBrand.accessOtherBrands ? (
                                    <AiOutlineCheckCircle className="text-green-600 text-lg" />
                                ) : (
                                    <AiOutlineCloseCircle className="text-red-600 text-lg" />
                                )}
                            </div>
                        </div>
                        <div className="flex flex-row-reverse gap-3 pt-3">
                            <button
                                type="button"
                                onClick={downloadCertificate}
                                className="flex items-center justify-center w-full gap-2 px-4 py-3 rounded-lg border border-primary-500 text-primary-500 hover:bg-primary-500 hover:text-white transition"
                            >
                                دانلود سرتیفیکیت
                                <FiDownload className="text-xl shrink-0" />

                            </button>
                            <button
                                type="button"
                                onClick={closeViewBrand}
                                className="px-4 py-3 w-full rounded-lg bg-gray-200 text-gray-800 font-bold hover:bg-gray-300"
                            >
                                بستن
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ViewBrand;